import { hotList } from '@/mocks/gossip';
import SectionHead from './SectionHead';

const trendIcon: Record<string, { cls: string; icon: string }> = {
  up: { cls: 'text-primary-600', icon: 'ri-arrow-up-line' },
  flat: { cls: 'text-accent-600', icon: 'ri-arrow-right-line' },
  down: { cls: 'text-secondary-500', icon: 'ri-arrow-down-line' },
};

export default function HotRank() {
  const featured = hotList[0];
  const rest = hotList.slice(1);
  const ftr = trendIcon[featured.trend];

  return (
    <section id="hot" className="scroll-mt-28 py-12 md:py-16 bg-background-100/60">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6">
        <SectionHead
          kicker="LIVE BOARD"
          kickerZh="实时更新 · 每 10 分钟刷新"
          title="今日热榜：谁在风口浪尖"
          desc="按讨论热度与涨幅实时排序。热度来源为全网公开讨论量与互动数据，帮助你第一时间锁定值得深挖的那条瓜。"
          action={
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-xs text-secondary-700 whitespace-nowrap">
              <i className="ri-refresh-line"></i>
              更新于刚刚
            </span>
          }
        />

        <div className="grid gap-5 lg:grid-cols-12">
          {/* featured */}
          <a
            href="#feed"
            className="group lg:col-span-5 flex flex-col justify-between overflow-hidden rounded-xl border border-background-200 bg-background-50 p-6 md:p-7 transition-colors hover:border-primary-300"
          >
            <div>
              <div className="flex items-center gap-3">
                <span className="font-heading text-5xl font-black text-primary-500">01</span>
                <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-700 whitespace-nowrap">
                  <i className="ri-hotspot-line"></i>
                  全网第一
                </span>
              </div>
              <h3 className="mt-4 font-heading text-xl md:text-2xl font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                {featured.title}
              </h3>
              <p className="mt-3 text-sm leading-7 text-foreground-600">
                新单曲上线的同一晚，从团体改名到品牌代言更替集中引爆。关联事件正以每小时数条的速度被网友拼出全貌，争议仍在发酵，编辑部持续跟进。
              </p>
            </div>
            <div className="mt-6 flex items-center justify-between border-t border-background-200 pt-4">
              <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 whitespace-nowrap">
                <i className="ri-fire-line"></i>
                {featured.heat} 热度
              </span>
              <span className="inline-flex items-center gap-2 text-sm text-foreground-500 whitespace-nowrap">
                查看完整瓜田地图
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </div>
          </a>

          {/* ranking list */}
          <div className="lg:col-span-7 flex flex-col gap-2.5">
            {rest.map((it, idx) => {
              const t = trendIcon[it.trend];
              return (
                <a
                  key={idx}
                  href="#topics"
                  className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3 md:px-5 transition-colors hover:border-primary-300 hover:bg-background-100/60"
                >
                  <span
                    className={`w-7 shrink-0 text-center font-heading text-base font-bold ${
                      idx < 2 ? 'text-primary-600' : idx === 2 ? 'text-accent-600' : 'text-secondary-400'
                    }`}
                  >
                    {idx + 2}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate text-sm md:text-[15px] font-medium text-foreground-900 group-hover:text-primary-700">
                      {it.title}
                    </span>
                  </span>
                  <span className="hidden md:inline-flex rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-700 whitespace-nowrap">
                    {it.tag}
                  </span>
                  <span className="hidden sm:inline-block w-20 text-right text-xs text-foreground-500 whitespace-nowrap">
                    {it.heat}
                  </span>
                  <span className={`flex items-center justify-center ${t.cls}`}>
                    <i className={`${t.icon} text-sm`}></i>
                  </span>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}